"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _react = _interopRequireWildcard(require("react")),
    _Player = _interopRequireDefault(require("../components/Player")),
    _Uploader = require("../../Uploader"),
    _Comments = require("../../Comments"),
    PlayerContainer = function PlayerContainer(a, b) {
  var c = a.assetId,
      d = (0, _objectWithoutProperties2["default"])(a, ["assetId"]);
  return _react["default"].createElement(_Uploader.UploaderConsumer, null, function (a) {
    var e = a.fetchAssets;
    return _react["default"].createElement(_Uploader.AssetSelector, {
      assetId: c
    }, function (a) {
      return _react["default"].createElement(_Comments.CommentsConsumer, null, function (f) {
        var g = f.state;
        g = void 0 === g ? {} : g;
        var h = g.commentModalId;
        return _react["default"].createElement(_Player["default"], (0, _extends2["default"])({}, d, {
          ref: b,
          assetId: c,
          asset: a,
          fetchAssets: e,
          commentModalId: h
        }));
      });
    });
  });
},
    _default = (0, _react.forwardRef)(PlayerContainer);

exports["default"] = _default;